import { createSlice } from "@reduxjs/toolkit";
import { Dispatch } from "react";
import { Microservices } from "../../app/AllowedMicroservices";
import { RootState } from "../../app/store";
import apiActionCreator, { HttpMethods } from "../../services/apiActionCreator";
import { FetchStatus } from "../common/enums";

// Mirrors PUT /progress-audit/progress/:progressId/topics/:topicId/finish
// (service-learning, SuperAdmin only) - the manual correction for a topic
// stuck at progress 0 although every lesson and its test are done, because
// the closing request never reached the backend (SYSTEM.debt.md ítem
// 29/§15.29).
interface ProgressAuditFinishTopicState {
  status: FetchStatus;
}

const initialState: ProgressAuditFinishTopicState = {
  status: FetchStatus.Idle,
};

export const progressAuditFinishTopicSlice = createSlice({
  name: "progressAuditFinishTopic",
  initialState,
  reducers: {
    fixing: (state) => {
      state.status = FetchStatus.Fetching;
    },
    fixed: (state) => {
      state.status = FetchStatus.Fetched;
    },
    error: (state) => {
      state.status = FetchStatus.Error;
    },
  },
});

export const { fixing, fixed, error } = progressAuditFinishTopicSlice.actions;

export const finishProgressAuditTopic = (
  progressId: string,
  topicId: string,
  onSuccess: () => void = () => {},
  onError: () => void = () => {}
) => (dispatch: Dispatch<object>) => {
  return dispatch(
    apiActionCreator({
      endpoint: `/progress-audit/progress/${progressId}/topics/${topicId}/finish`,
      types: {
        requestType: fixing,
        successTypes: [
          {
            actionOrCreator: fixed,
            selector: () => {
              onSuccess();
            },
          },
        ],
        errorTypes: [
          {
            actionOrCreator: error,
            selector: () => {
              onError();
            },
          },
        ],
      },
      method: HttpMethods.PUT,
      microservice: Microservices.LEARNING_SERVICE,
      authenticated: true,
    })
  );
};

export const selectIsFinishingProgressAuditTopic = (state: RootState) =>
  state.progressAuditFinishTopic.status === FetchStatus.Fetching;

export default progressAuditFinishTopicSlice.reducer;
